import { type FC, type HTMLAttributes, type ReactNode } from 'react'

import './index.scss'

export interface LargeBodyTextProps extends HTMLAttributes<HTMLParagraphElement> {
  children: ReactNode
  className?: string
}

export const LargeBodyText: FC<LargeBodyTextProps> = ({ children, className = '', ...rest }) => (
  <p className={`large-body-text ${className}`} {...rest}>
    {children}
  </p>
)
